import {
  buildBubbleEventFromChartRenderEventList,
  DEFAULT_OPINION_BUBBLE_EVENT_TYPES,
} from './buildBubbleEventFromChartRenderEventList';
import { buildBubbleEventFromSelectedKeys } from './buildBubbleEventFromSelectedKeys';
import type { IPersistedOpinionChartEventSetting } from './opinionChartEventSettingStorage';
import { remapChartRenderEventListToXAxis } from './remapOpinionEventTimelineToXAxis';
import type {
  IOpinionChartEventData,
  IOpinionChartEventSetting,
} from '../types';

interface IBuildInitialChartEventSettingOptions {
  eventData: IOpinionChartEventData;
  currentSetting: IOpinionChartEventSetting;
  persistedSetting?: IPersistedOpinionChartEventSetting | null;
  xAxisData?: string[];
  dateType?: string;
}

/** 首次初始化 bubbleEvent：优先 session 缓存，否则默认类型 */
export function buildInitialChartEventSetting(
  options: IBuildInitialChartEventSettingOptions,
): IOpinionChartEventSetting {
  const {
    eventData,
    currentSetting,
    persistedSetting,
    xAxisData = [],
    dateType,
  } = options;

  if (persistedSetting?.isCustomized && persistedSetting.selectedEventKeys) {
    return {
      ...currentSetting,
      bubbleEvent: buildBubbleEventFromSelectedKeys(
        eventData.eventList,
        persistedSetting.selectedEventKeys,
        {
          xAxisData,
          dateType,
          timeFormat: eventData.format,
        },
      ),
      showEventAxis: persistedSetting.showEventAxis,
      showEventBubbles: persistedSetting.showEventBubbles,
    };
  }

  const remappedChartRenderEventList = xAxisData.length
    ? remapChartRenderEventListToXAxis(
        eventData.chartRenderEventList,
        xAxisData,
        dateType,
        eventData.format,
      )
    : eventData.chartRenderEventList;

  return {
    ...currentSetting,
    bubbleEvent: buildBubbleEventFromChartRenderEventList(
      remappedChartRenderEventList,
      { eventTypes: DEFAULT_OPINION_BUBBLE_EVENT_TYPES },
    ),
    showEventBubbles: currentSetting.showEventBubbles !== false,
  };
}

export function hasBubbleEventContent(
  bubbleEvent?: Record<string, unknown[]>,
): boolean {
  return Object.keys(bubbleEvent || {}).length > 0;
}
